import { BinderSummary } from "@dune/types";
import { Button, Checkbox } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "date-fns";
import { ArrowUpDown } from "lucide-react";

export const bindersListColumns: ColumnDef<BinderSummary>[] = [
	{
		id: "select",
		header: ({ table }) => (
			<Checkbox
				checked={
					table.getIsAllPageRowsSelected() ||
					(table.getIsSomePageRowsSelected() && "indeterminate")
				}
				onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
				aria-label="Select all"
			/>
		),
		cell: ({ row }) => (
			<Checkbox
				checked={row.getIsSelected()}
				onCheckedChange={(value) => row.toggleSelected(!!value)}
				aria-label="Select row"
			/>
		),
		enableSorting: false,
		enableHiding: false,
	},
	{
		accessorKey: "reference",
		header: ({ column }) => {
			return (
				<Button
					variant="none"
					size="none"
					onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
				>
					Ref
					<ArrowUpDown />
				</Button>
			);
		},
		cell: ({ row }) => <div>{row.getValue("reference")}</div>,
	},
	{
		accessorKey: "name",
		header: ({ column }) => {
			return (
				<Button
					variant="none"
					size="none"
					onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
				>
					Produit
					<ArrowUpDown />
				</Button>
			);
		},
		cell: ({ row }) => <div>{row.getValue("name")}</div>,
	},
	{
		accessorKey: "insurer.society.companyName",
		header: "Assureur",
	},
	{
		accessorKey: "binderAmendments",
		header: "Date d'effet",
		cell: ({ row }) => {
			const lastAmendment = row.original.binderAmendments?.[0];
			if (!lastAmendment?.effectiveDate) return null;
			return <div>{formatDate(lastAmendment.effectiveDate, "dd/MM/yyyy")}</div>;
		},
	},
	{
		accessorKey: "avenant",
		header: "Avenant",
		cell: ({ row }) => <div>{row.original.binderAmendments?.length ?? 0}</div>,
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			if (
				row.original.binderAmendments?.[0]?.effectiveDate &&
				row.original.binderAmendments?.[0]?.endDate
			) {
				return row.original.binderAmendments?.[0]?.effectiveDate <=
					row.original.binderAmendments?.[0]?.endDate ? (
					<div>Actif</div>
				) : (
					<div>Expiré</div>
				);
			}
			return <div>Expiré</div>;
		},
	},
];
